function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * First-pass NFT execution-risk classification.
 * Not a complete security scanner. Unknown / unscannable content is never Low.
 *
 * Low        — no code-execution path in the base Saito/browser context
 * Medium     — potentially executable; requires manual review (CSS/JS default)
 * High       — significant risk; unusually careful review; obfuscated but not in an executable field
 * Dangerous  — concrete security problem, or obfuscated code in an executable context (JS/CSS/SVG)
 */

var LEVELS = Object.freeze(['Low', 'Medium', 'High', 'Dangerous']);
var RANK = Object.freeze({
  Low: 0,
  Medium: 1,
  High: 2,
  Dangerous: 3
});
var RASTER_IMAGE_MIMES = new Set(['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp']);
var WALLET_ACCESS_RE = /app\.options|\bwallet\b/i;

// CSS constructs that are known to execute script or load executable payloads
// in browser CSS engines (including historical engines Saito cannot assume away).
var CSS_SCRIPT_EXEC_RES = [/expression\s*\(/i, /javascript\s*:/i, /behavior\s*:/i, /-ms-behavior\s*:/i, /-moz-binding\s*:/i, /progid\s*:\s*DXImageTransform/i, /url\s*\(\s*['"]?\s*javascript\s*:/i, /url\s*\(\s*['"]?\s*vbscript\s*:/i, /url\s*\(\s*['"]?\s*data\s*:\s*(text\/(javascript|ecmascript|html)|application\/(javascript|ecmascript|x-javascript))/i, /@import\s+(?:url\s*\()?\s*['"]?\s*data\s*:/i];
var CSS_HARD_REVIEW_RES = [/url\s*\(\s*['"]?\s*data\s*:\s*image\/svg/i, /@import\s+/i, /-webkit-image-set\s*\(/i, /-o-link\s*:/i, /[\s;{]binding\s*:/i];
var KNOWN_PAYLOAD_KEYS = new Set(['image', 'css', 'js', 'text', 'expires_at', 'title', 'description', 'path']);

// Opaque containers we will not unpack. Presence alone is High.
var OPAQUE_BINARY_KEYS = new Set(['file', 'zip', 'rom', 'mod', 'wasm', 'binary', 'archive', 'bundle', 'pkg', 'nwasm']);
var OPAQUE_BINARY_DATA_URI_RE = /data:\s*(application\/(zip|x-zip-compressed|x-7z-compressed|gzip|x-gzip|x-tar|wasm|octet-stream|vnd\.rar|x-n64-rom|x-gba-rom)|application\/x-wasm)/i;
var JS_DYNAMIC_EXEC_RES = [/\beval\s*\(/, /\bnew\s+Function\s*\(/, /\bFunction\s*\(/, /\bsetTimeout\s*\(\s*['"`]/, /\bsetInterval\s*\(\s*['"`]/, /\bimport\s*\(/, /\bdocument\.write\s*\(/, /\.innerHTML\s*=/, /\.outerHTML\s*=/, /\bexecScript\s*\(/];
var OBFUSCATION_RES = [/\bunescape\s*\(/i, /\batob\s*\(/, /\bbtoa\s*\(/, /\bfromCharCode\s*\(/, /\bfromCodePoint\s*\(/, /\bdecodeURIComponent\s*\(/i, /\bdecodeURI\s*\(/, /\beval\s*\(\s*function\s*\(/i, /\\x[0-9a-fA-F]{2}/, /\\u[0-9a-fA-F]{4}/, /\\u\{[0-9a-fA-F]+\}/, /\\[0-7]{3}/, /&#x?[0-9a-fA-F]+;/i, /(?:%[0-9a-fA-F]{2}){4,}/];
function worse(a, b) {
  var left = LEVELS.includes(a) ? a : 'Medium';
  var right = LEVELS.includes(b) ? b : 'Medium';
  return RANK[left] >= RANK[right] ? left : right;
}
function asText(value) {
  if (value == null) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  try {
    return JSON.stringify(value);
  } catch (err) {
    return String(value);
  }
}
function decodeCssEscapes() {
  var css = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(css).replace(/\\([0-9a-fA-F]{1,6})\s?/g, function (_, hex) {
    var code = parseInt(hex, 16);
    return Number.isFinite(code) ? String.fromCharCode(code) : '';
  }).replace(/\\(.)/g, '$1');
}
function decodeJsEscapes() {
  var js = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(js).replace(/\\x([0-9a-fA-F]{2})/g, function (_, hex) {
    return String.fromCharCode(parseInt(hex, 16));
  }).replace(/\\u([0-9a-fA-F]{4})/g, function (_, hex) {
    return String.fromCharCode(parseInt(hex, 16));
  });
}
function scanLevels(source, regexes) {
  return regexes.some(function (re) {
    return re.test(source);
  });
}
function hexEscapeDecodesToCode() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var hex = /\\([0-9a-fA-F]{1,6})\s?/g;
  var match;
  while (match = hex.exec(source)) {
    var code = parseInt(match[1], 16);
    if (!Number.isFinite(code)) {
      continue;
    }
    // Escaped ASCII letters/digits/punctuation hide keywords from plaintext review.
    if (code >= 33 && code <= 126) {
      return true;
    }
  }
  return false;
}
function sourceLooksObfuscated() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var s = asText(source);
  if (!s) {
    return false;
  }
  if (scanLevels(s, OBFUSCATION_RES)) {
    return true;
  }
  if (hexEscapeDecodesToCode(s)) {
    return true;
  }
  return false;
}
function obfuscationRank(executable) {
  return executable ? 'Dangerous' : 'High';
}
function returnTxMessage(tx) {
  if (!tx) {
    return {};
  }
  if (typeof tx.returnMessage === 'function') {
    try {
      return tx.returnMessage() || {};
    } catch (err) {
      return tx.msg || {};
    }
  }
  return tx.msg && _typeof(tx.msg) === 'object' ? tx.msg : {};
}
function payloadFromTx(tx) {
  var txmsg = returnTxMessage(tx);
  var data = txmsg.data && _typeof(txmsg.data) === 'object' && !Array.isArray(txmsg.data) ? txmsg.data : {};
  return {
    txmsg: txmsg,
    data: data
  };
}
function imageMime() {
  var dataUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var match = String(dataUri).match(/^data:([^;,]+)/i);
  if (!match) {
    return '';
  }
  var mime = match[1].toLowerCase();
  if (mime === 'image/jpg') {
    mime = 'image/jpeg';
  }
  return mime;
}
function checkImageSecurity() {
  var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var src = String(image || '');
  if (!src) {
    return 'Low';
  }
  if (/^\s*data:/i.test(src)) {
    var mime = imageMime(src);
    if (!mime.startsWith('image/')) {
      return 'Dangerous';
    }
    if (mime === 'image/svg+xml' || mime.startsWith('image/svg')) {
      // Base64 SVG hides markup from review and can contain script.
      if (/;base64,/i.test(src) || sourceLooksObfuscated(src)) {
        return 'Dangerous';
      }
      if (/<script/i.test(src) || /javascript\s*:/i.test(src) || /\bon\w+\s*=/i.test(src) || WALLET_ACCESS_RE.test(src)) {
        return 'Dangerous';
      }
      return 'Medium';
    }
    if (RASTER_IMAGE_MIMES.has(mime)) {
      return 'Low';
    }
    return 'Medium';
  }
  if (/^https?:\/\//i.test(src) || src.startsWith('/')) {
    return 'Medium';
  }
  return 'Medium';
}
function checkCSSSecurity() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var css = asText(source);
  if (!css.trim()) {
    return 'Medium';
  }
  var decoded = decodeCssEscapes(css);
  var haystacks = decoded === css ? [css] : [css, decoded];
  for (var _i = 0, _haystacks = haystacks; _i < _haystacks.length; _i++) {
    var text = _haystacks[_i];
    if (scanLevels(text, CSS_SCRIPT_EXEC_RES)) {
      return 'Dangerous';
    }
  }
  if (sourceLooksObfuscated(css) || decoded !== css && hexEscapeDecodesToCode(css)) {
    return 'Dangerous';
  }
  for (var _i2 = 0, _haystacks2 = haystacks; _i2 < _haystacks2.length; _i2++) {
    var _text = _haystacks2[_i2];
    if (WALLET_ACCESS_RE.test(_text)) {
      return 'High';
    }
    if (scanLevels(_text, CSS_HARD_REVIEW_RES)) {
      return 'High';
    }
  }
  return 'Medium';
}
function checkJSSecurity() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var js = asText(source);
  if (!js.trim()) {
    return 'Medium';
  }
  var decoded = decodeJsEscapes(js);
  var haystacks = decoded === js ? [js] : [js, decoded];
  for (var _i3 = 0, _haystacks3 = haystacks; _i3 < _haystacks3.length; _i3++) {
    var text = _haystacks3[_i3];
    if (WALLET_ACCESS_RE.test(text)) {
      return 'Dangerous';
    }
  }
  if (sourceLooksObfuscated(js) || sourceLooksObfuscated(decoded)) {
    return 'Dangerous';
  }
  for (var _i4 = 0, _haystacks4 = haystacks; _i4 < _haystacks4.length; _i4++) {
    var _text2 = _haystacks4[_i4];
    if (scanLevels(_text2, JS_DYNAMIC_EXEC_RES)) {
      return 'High';
    }
  }
  return 'Medium';
}
function looksLikeOpaqueBinary(value) {
  var s = asText(value);
  if (!s) {
    return false;
  }
  if (OPAQUE_BINARY_DATA_URI_RE.test(s)) {
    return true;
  }
  if (s.startsWith('PK\x03\x04') || s.startsWith('\0asm')) {
    return true;
  }
  // ZIP / WASM magic as base64 ("PK.." / "\0asm")
  if (s.startsWith('UEsDB') || s.startsWith('AGFzbQ')) {
    return true;
  }
  return false;
}
function containsOpaqueBinary(value) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (depth > 6 || value == null) {
    return false;
  }
  if (typeof value === 'string') {
    return looksLikeOpaqueBinary(value);
  }
  if (_typeof(value) !== 'object') {
    return false;
  }
  var entries = Array.isArray(value) ? value.map(function (item, i) {
    return [String(i), item];
  }) : Object.entries(value);
  var _iterator = _createForOfIteratorHelper(entries),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        nested = _step$value[1];
      if (OPAQUE_BINARY_KEYS.has(String(key).toLowerCase()) && nested) {
        return true;
      }
      if (containsOpaqueBinary(nested, depth + 1)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
}
function checkTextSecurity() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = asText(text);
  if (!value.trim()) {
    return 'Low';
  }
  var executable_markup = /<script/i.test(value) || /javascript\s*:/i.test(value) || /^\s*</.test(value);
  if (executable_markup) {
    if (/<script/i.test(value) || /javascript\s*:/i.test(value) || WALLET_ACCESS_RE.test(value)) {
      return 'Dangerous';
    }
    if (sourceLooksObfuscated(value)) {
      return 'Dangerous';
    }
    return 'Medium';
  }
  if (sourceLooksObfuscated(value)) {
    return 'High';
  }
  if (WALLET_ACCESS_RE.test(value)) {
    return 'High';
  }
  return 'Low';
}

/**
 * @param {*} tx listing or mint transaction (must expose returnMessage() or .msg)
 * @returns {"Low"|"Medium"|"High"|"Dangerous"}
 */
function checkSecurityLevel(tx) {
  if (!tx) {
    return 'Medium';
  }
  var data = {};
  try {
    data = payloadFromTx(tx).data;
  } catch (err) {
    return 'Medium';
  }
  var levels = [];
  if (typeof data.js !== 'undefined' && data.js !== null) {
    levels.push(String(data.js).length ? checkJSSecurity(data.js) : 'Medium');
  }
  if (typeof data.css !== 'undefined' && data.css !== null) {
    levels.push(String(data.css).length ? checkCSSSecurity(data.css) : 'Medium');
  }
  if (typeof data.image !== 'undefined' && data.image) {
    levels.push(checkImageSecurity(data.image));
  }
  if (typeof data.text !== 'undefined' && data.text) {
    levels.push(checkTextSecurity(data.text));
  }
  var executable_payload = typeof data.js !== 'undefined' && data.js !== null || typeof data.css !== 'undefined' && data.css !== null;
  if (containsOpaqueBinary(data)) {
    levels.push(obfuscationRank(executable_payload));
  }
  var blob = asText(data);
  if (typeof data.js === 'undefined' && /\bfunction\b|\beval\s*\(/.test(blob)) {
    levels.push(checkJSSecurity(blob));
  }
  if (typeof data.css === 'undefined' && /\{[^}]*:[^}]*\}/.test(blob) && /url\s*\(|expression\s*\(/i.test(blob)) {
    levels.push(checkCSSSecurity(blob));
  }
  var unknown_keys = Object.keys(data).filter(function (key) {
    return !KNOWN_PAYLOAD_KEYS.has(key);
  });
  if (unknown_keys.length) {
    if (sourceLooksObfuscated(blob)) {
      levels.push('High');
    } else if (WALLET_ACCESS_RE.test(blob)) {
      levels.push('High');
    } else {
      levels.push('Medium');
    }
  }
  if (!levels.length) {
    // No analyzable payload — not Low, because we could not prove it is display-only.
    return 'Medium';
  }
  return levels.reduce(worse, 'Low');
}
module.exports = {
  checkSecurityLevel: checkSecurityLevel,
  checkCSSSecurity: checkCSSSecurity,
  checkJSSecurity: checkJSSecurity
};